import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { CloseSquareOutlined, CopyOutlined, DownloadOutlined, EyeOutlined, FilePdfOutlined, FileZipOutlined, FormOutlined, LinkOutlined, MinusCircleOutlined, PlusOutlined, ReloadOutlined, ShopOutlined, TagsOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tag, Tooltip } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import HasPermissions from "../../../../../containers/HasPermissions";
import ConsignmentStatusType from "../../../enums/ConsignmentStatusType";
import ConsignmentDeliveryDate from "../../../components/ConsignmentDeliveryDate";
import ConsignmentAssignVehicleModal from "../ConsignmentAssignVehicleModal";
import ConsignmentUnassignVehicleModal from "../ConsignmentUnassignVehicleModal";
import ConsignmentCancelModal from "../ConsignmentCancelModal";
import ConsignmentMarketplaceModal from "../ConsignmentMarketplaceModal";
import ConsignmentWithdrawFromMarketModal from "../ConsignmentWithdrawFromMarketModal";
import AddressSuburbPopover, { AddressSuburbPopoverConstants } from "../AddressSuburbPopover";
import ConsignmentStatusText from "../ConsignmentStatusText";
import ConsignmentFreightPopover from "../ConsignmentFreightPopover";
import { getDivisionName, isUserMultiTenant, shouldShowDivision, userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import GlobalConstants from "../../../../../swzutils/GlobalConstants";
import PermissionDropdownButton from "../../../components/PermissionDropdownButton";
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import { ConsignmentStatusEnum } from "../api/Representation";
import API from "../../../../../API";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { PARAM_CLONE_CONSIGNMENT_ID } from "../create/CreateWizard";
import { isBlankNullOrUndefined, isStringNotBlank } from "../../../../../swzutils/TypeUtils";
import PermissionButton from "../../../components/PermissionButton";
import DeliveryAddressTableFilterBuilder from "../../../components/table/DeliveryAddressTableFilter";
import CustomerProjectStage from "../../../enums/CustomerProjectStage";
import { formatName } from "../../../../../util/FormatUtil";
import qtyRangeUOMSearchTableFilter from "../../../components/table/QtyRangeUOMSearchTableFilter";
import { useAppSelector } from "../../../../../store";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../../store/slice/auth";
import axios from "axios";
import { axiosErrorHandler, downloadAsFile, parseContentDispositionHeader, showErrorNotification } from "../../../../../swzutils";
import ConsignmentInstructionsPatchModal from "../ConsignmentInstructionsPatchModal";
export const PARAM_FILTER_SALES_ORDER_REF = 'filterSalesOrderRef';
const ConsignmentsTable = ({ url = "/admin/v1/consignments", showOrderRefColumn = true, showProfileColumn = true, showCustomerColumn = true, showButtonBar = true, }) => {
    const [stateAssignConsignment, setStateAssignConsignment] = useState(null);
    const [stateUnassignConsignmentId, setStateUnassignConsignmentId] = useState(null);
    const [stateUnassignConsignmentVersion, setStateUnassignConsignmentVersion] = useState(null);
    const [stateAssignedVehicleId, setStateAssignedVehicleId] = useState(null);
    const [stateCancelConsignmentId, setStateCancelConsignmentId] = useState(null);
    const [stateCancelConsignmentVersion, setStateCancelConsignmentVersion] = useState(null);
    const [statePlaceOnMarketConsignment, setStatePlaceOnMarketConsignment] = useState(undefined);
    const [stateWithdrawFromMarketConsignment, setStateWithdrawFromMarketConsignment] = useState(null);
    const [stateEditNotesConsignment, setStateEditNotesConsignment] = useState(null);
    const [stateAssignedAction, setStateAssignedAction] = useState(null);
    const [stateDownloadingPODsZip, setStateDownloadingPODsZip] = useState(false);
    const tableRef = useRef(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams /*, setSearchParams*/] = useSearchParams();
    const [filterSalesOrderRefQueryParam /*, setFilterSalesOrderRefQueryParam*/] = useState(searchParams.get(PARAM_FILTER_SALES_ORDER_REF));
    useEffect(() => {
        onSearchParamsChanged(searchParams);
    }, [location.search]);
    const onSearchParamsChanged = (queryParams) => {
        if (queryParams && (queryParams.get("assignedVehicleId") || queryParams.get("unassignConsignmentId") || queryParams.get("cancelConsignmentId"))) {
            setStateUnassignConsignmentId(queryParams.get("unassignConsignmentId"));
            setStateUnassignConsignmentVersion(queryParams.get("unassignConsignmentVersion"));
            setStateAssignedVehicleId(queryParams.get("assignedVehicleId"));
            setStateAssignedAction(queryParams.get("assignedAction"));
            setStateCancelConsignmentId(queryParams.get("cancelConsignmentId"));
            setStateCancelConsignmentVersion(queryParams.get("version"));
        }
        else {
            setStateUnassignConsignmentId(null);
            setStateUnassignConsignmentVersion(null);
            setStateAssignedVehicleId(null);
            setStateAssignedAction(null);
            setStateCancelConsignmentId(null);
            setStateCancelConsignmentVersion(null);
        }
        const orderRef = queryParams.get(PARAM_FILTER_SALES_ORDER_REF);
        if (orderRef && isStringNotBlank(orderRef)) {
            tableRef.current?.applyFilter("salesOrderRefLike", [orderRef]);
        }
    };
    const closeDialog = () => {
        navigate(location.pathname, {
            replace: true,
        });
    };
    const showPlaceOnMarketModal = (consignment) => setStatePlaceOnMarketConsignment(consignment);
    const hidePlaceOnMarketModal = () => setStatePlaceOnMarketConsignment(undefined);
    const showWithdrawFromMarketModal = (consignment) => setStateWithdrawFromMarketConsignment(consignment);
    const hideWithdrawFromMarketModal = () => setStateWithdrawFromMarketConsignment(null);
    const showAssignVehicleModal = (consignment) => setStateAssignConsignment(consignment);
    const hideAssignVehicleModal = () => setStateAssignConsignment(null);
    const showEditNotesConsignment = (consignment) => setStateEditNotesConsignment(consignment);
    const hideEditNotesConsignment = () => setStateEditNotesConsignment(null);
    const onConsignmentCancelled = () => {
        refresh();
        closeDialog();
    };
    const refresh = () => {
        tableRef.current?.fetch();
    };
    const downloadAllPODsAsZip = () => {
        const filters = tableRef.current?.getCurrentFilters();
        setStateDownloadingPODsZip(true);
        axios('/admin/v1/consignments/proof-of-deliveries', {
            method: "get",
            params: {
                ...filters,
                status: ['COMPLETED']
            },
            responseType: 'blob'
        }).then(response => {
            if (response.data) {
                const cd = parseContentDispositionHeader(response.headers['content-disposition']);
                let fileName = cd?.parameters['filename'] ?? cd?.parameters['name'] ?? `Proof of Deliveries for ${selectedTenant?.name}.zip`;
                downloadAsFile(response.data, fileName);
            }
            else {
                showErrorNotification('No Consignment Proof of Deliveries found for the current filters');
            }
        }).catch(axiosErrorHandler)
            .finally(() => setStateDownloadingPODsZip(false));
    };
    const downloadCsv = () => {
        tableRef.current?.downloadCurrentFilterAsCsv("consignments");
    };
    const divisionName = getDivisionName(loggedInUser, selectedTenant);
    const columns = [{
            title: 'Delivery Date',
            key: 'deliveryDateKey',
            className: "nowrap",
            render: (text, record) => {
                return (_jsx(ConsignmentDeliveryDate, { consignment: record }));
            },
            filter: {
                type: 'dateRange',
                requestKey: 'deliveryAfterDate',
                requestKeyDateTo: 'deliveryBeforeDate'
            }
        }, {
            title: 'Con. No.',
            dataIndex: 'consignmentRef',
            className: "nowrap",
            filter: {
                type: 'text',
                placeholder: 'Search ref',
                requestKey: 'consignmentRef'
            }
        }, {
            title: 'Ord. Ref.',
            key: 'salesOrderRefLike',
            dataIndex: 'salesOrderRef',
            className: "nowrap",
            condition: showOrderRefColumn,
            filter: {
                type: 'text',
                placeholder: 'Search ref',
                requestKey: 'salesOrderRefLike'
            },
            render: (text, record) => {
                let tag = null;
                if (record.salesOrder?.customerProjectStage) {
                    let customerProjectStage = CustomerProjectStage.valueOf(record.salesOrder?.customerProjectStage);
                    tag = customerProjectStage?.renderTag();
                }
                let link = null;
                if (record.salesOrder?.id) {
                    link = _jsx("a", { href: `#/app/sales-orders/view/${record.salesOrder.id}`, children: _jsx(LinkOutlined, {}) });
                }
                return _jsxs(_Fragment, { children: [text, _jsx("br", {}), tag, link] });
            }
        }, {
            title: 'Cust. Ref.',
            key: 'customerRef',
            dataIndex: 'customerRef',
            className: "nowrap",
            filter: {
                type: 'text',
                placeholder: 'Search ref',
                requestKey: 'customerRefLike'
            }
        }, {
            title: 'Profile',
            dataIndex: 'tenantName',
            sorter: false,
            condition: showProfileColumn && isUserMultiTenant(loggedInUser) && !selectedTenant?.id
        }, {
            title: divisionName,
            dataIndex: 'division',
            sorter: false,
            condition: shouldShowDivision(loggedInUser, selectedTenant),
            filter: {
                type: 'text',
                placeholder: divisionName,
                requestKey: 'divisionNameLike'
            },
            render: (text, record) => {
                if (record.division) {
                    return _jsx(Tag, { children: record.division.name }, record.division.id);
                }
                return null;
            }
        }, {
            title: _jsx(Tooltip, { placement: "top", title: "Marketplace", trigger: "hover", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }),
            key: 'marketplaceListed',
            filterMultiple: false,
            filter: {
                type: 'enum',
                requestKey: 'marketplaceListed',
                enums: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No', value: 'false' },
                ],
                filterMultiple: false
            },
            render: (text, record) => {
                return record.marketplaceListings && record.marketplaceListings.length ? "Yes" : "No";
            }
        }, {
            title: 'Rego(s)',
            dataIndex: 'vehicleRegistration',
            className: "nowrap",
            filter: {
                type: 'text',
                placeholder: 'Registration',
                requestKey: 'registrationLike',
                forceUppercase: true
            },
            render: (text, record) => {
                if (record.assignedVehicles && record.assignedVehicles.length) {
                    return record.assignedVehicles
                        .map(cav => (_jsxs("span", { children: [cav.vehicle.registration, _jsx("br", {})] }, cav.id)));
                }
                return null;
            },
        }, {
            title: 'Completed By',
            dataIndex: 'completedBy',
            filter: {
                type: 'text',
                placeholder: 'Completed By',
                requestKey: 'completedByDriverNameLike'
            },
            render: (text, record) => {
                const completedBy = record.completedBy;
                if (completedBy && completedBy.id) {
                    return formatName(completedBy.firstName, completedBy.lastName);
                }
                return null;
            },
        }, {
            title: 'Pickup Location',
            key: 'pickupAddress',
            render: (text, record) => (_jsx(AddressSuburbPopover, { address: record.pickupAddress, title: record.pickupCompanyName, canEditTenantId: record.tenantId, canEditConsignmentId: userHasPermission(loggedInUser, ['admin:consignment:update']) ? record.id : null, canEditWaypointId: record.pickupWaypointId, isPickup: true, editMode: record.status === ConsignmentStatusEnum.COMPLETED ? AddressSuburbPopoverConstants.EDIT_MODE_NONE : AddressSuburbPopoverConstants.EDIT_MODE_PAGE })),
            filter: {
                type: 'text',
                placeholder: 'Pickup Name',
                requestKey: 'pickupNameLike'
            },
        }, {
            title: 'Customer',
            key: "customerNameLike",
            dataIndex: ['customer', 'name'],
            condition: showCustomerColumn,
            filter: {
                type: "text",
                placeholder: 'Search name',
                requestKey: 'customerNameLike'
            }
        }, {
            title: 'Instructions',
            render: (text, record) => {
                return (_jsxs("div", { style: {
                        maxWidth: '100px',
                        maxLines: 2,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'pre',
                        display: 'block',
                        wordWrap: 'break-word',
                        overflow: 'hidden',
                        padding: '0',
                        margin: '0',
                        maxHeight: '3.6em',
                        lineHeight: '1.8em'
                    }, children: [record.status !== ConsignmentStatusEnum.COMPLETED &&
                            _jsxs(_Fragment, { children: [_jsx(FormOutlined, { style: { fontSize: '1.3em' }, onClick: () => { showEditNotesConsignment(record); } }), "\u00A0"] }), record.instructions] }));
            }
        }, {
            title: 'Delivery Location',
            key: 'deliveryAddress',
            filter: {
                type: "custom",
                requestKey: 'deliveryAddress',
                builder: DeliveryAddressTableFilterBuilder
            },
            render: (text, record) => {
                const editConsignmentId = userHasPermission(loggedInUser, ['admin:consignment:update'])
                    ? record.id
                    : null;
                return (_jsx(AddressSuburbPopover, { address: record.deliveryAddress, title: record.deliveryCompanyName, canEditTenantId: record.tenantId, canEditConsignmentId: editConsignmentId, canEditConsignmentCreationSource: record.creationSource, canEditSalesOrderCustomerProjectStageEnum: record.salesOrder?.customerProjectStage, canEditWaypointId: record.deliveryWaypointId, isPickup: false, editMode: record.status === ConsignmentStatusEnum.COMPLETED ? AddressSuburbPopoverConstants.EDIT_MODE_NONE : AddressSuburbPopoverConstants.EDIT_MODE_PAGE }));
            },
        }, {
            title: 'Partner',
            key: 'hasPartnerAssigned',
            filter: {
                type: "enum",
                enums: [
                    { text: 'Yes', value: 'true' },
                    { text: 'No ', value: 'false' }
                ],
                filterMultiple: false,
                requestKey: 'hasPartnerAssigned'
            },
            render: (text, record) => {
                if (record.carrier) {
                    return record.carrier.name;
                }
                if (record.assignedVehicles && record.assignedVehicles.length) {
                    return record.assignedVehicles
                        .filter(cav => cav.vehicle.tenantId !== record.tenantId)
                        .map(cav => (_jsxs("span", { children: [cav.vehicle.tenantName, _jsx("br", {})] }, cav.id)));
                }
                return null;
            },
        }, {
            title: 'Status',
            dataIndex: 'status',
            filter: {
                type: 'enum',
                enums: ConsignmentStatusType.filtersArray(),
                requestKey: 'status',
                filterMultiple: true
            },
            render: (text, record) => (_jsx(ConsignmentStatusText, { consignment: record }))
        }, {
            title: 'Freight',
            filter: {
                type: "custom",
                requestKey: 'freight',
                builder: qtyRangeUOMSearchTableFilter('freightQtyEqualOrGreaterThan', 'freightQtyEqualOrLessThan', 'freightUnitOfMeasure', {
                    placeholder: 'Product',
                    requestKey: 'freightProductLike'
                })
            },
            render: (text, record) => (_jsx(ConsignmentFreightPopover, { consignment: record, forcePopover: true }))
        }, {
            title: 'Action',
            key: 'action',
            render: (text, consignment) => {
                const consignmentStatus = ConsignmentStatusType.valueOf(consignment.status);
                const deliverMarketplaceListing = consignment.marketplaceListings && consignment.marketplaceListings.length
                    ? consignment.marketplaceListings.find(it => it.consignmentAction === 'DELIVER')
                    : null;
                return (_jsx(PermissionDropdownButton, { label: _jsx(EyeOutlined, {}), permissions: ['admin:consignment:view'], onClick: () => {
                        navigate('/app/consignments/view/' + consignment.id);
                    }, menuItems: [{
                            key: "app/consignment/assign",
                            permissions: ['admin:consignmentVehicle:assignToCarrier', 'admin:consignmentVehicle:assignToContractor', 'admin:consignmentVehicle:assignToFleet'],
                            condition: consignment.status !== 'COMPLETED',
                            onClick: () => showAssignVehicleModal(consignment),
                            icon: _jsx(FontAwesomeIcon, { icon: faTruck }),
                            label: "Assign"
                        }, {
                            key: "app/consignment/unassign",
                            permissions: ['admin:consignmentVehicle:unassign'],
                            condition: !!(consignment.status !== 'COMPLETED' && consignment.assignedVehicles && consignment.assignedVehicles.length),
                            route: (consignment.assignedVehicles && consignment.assignedVehicles.length) ? `#/app/consignments/list?unassignConsignmentId=${consignment.id}&unassignConsignmentVersion=${consignment.version}&assignedVehicleId=${consignment.assignedVehicles[0].vehicle.id}&assignedAction=${consignment.assignedVehicles[0].action}` : undefined,
                            icon: _jsx(MinusCircleOutlined, {}),
                            label: "Unassign"
                        }, {
                            key: 'app/consignment/place-on-market',
                            permissions: ['admin:consignmentMarketplace:create'],
                            condition: !deliverMarketplaceListing && consignmentStatus != null && consignmentStatus.canAddOrRemoveFromMarket(),
                            icon: _jsx(ShopOutlined, {}),
                            label: "Place on Market",
                            onClick: () => showPlaceOnMarketModal(consignment)
                        }, {
                            key: 'app/consignment/withdraw-from-market',
                            permissions: ['admin:consignmentMarketplace:delete'],
                            condition: !!(deliverMarketplaceListing && consignmentStatus != null && consignmentStatus.canAddOrRemoveFromMarket()),
                            icon: _jsx(MinusCircleOutlined, {}),
                            label: "Remove from Market",
                            onClick: () => showWithdrawFromMarketModal(consignment)
                        }, {
                            key: "app/consignment/cancel",
                            permissions: ['admin:consignment:delete'],
                            route: `#/app/consignments/list?cancelConsignmentId=${consignment.id}&version=${consignment.version}`,
                            condition: consignment.status !== 'CANCELLED' && (consignment.status !== 'COMPLETED' || userHasPermission(loggedInUser, ['subtruxAdminAccounts:cancelCompletedConsignment'])),
                            icon: _jsx(CloseSquareOutlined, {}),
                            label: "Cancel"
                        }, {
                            key: "app/consignment/clone",
                            permissions: ['admin:consignment:create'],
                            route: `#/app/consignments/create/details?${PARAM_CLONE_CONSIGNMENT_ID}=${consignment.id}`,
                            icon: _jsx(CopyOutlined, {}),
                            label: "Duplicate/Clone"
                        }, {
                            key: "app/consignment/proofOfDelivery",
                            permissions: ['admin:consignmentDocument:proofOfDelivery'],
                            route: `${API.origin()}/admin/v1/consignments/${consignment.id}/documents/proof-of-delivery`,
                            target: GlobalConstants.PDF_WINDOW_TARGET_NAME,
                            icon: _jsx(FilePdfOutlined, {}),
                            label: "Proof of Delivery"
                        }, {
                            key: "app/consignment/shippingLabel",
                            permissions: ['admin:consignmentDocument:shippingLabel'],
                            route: `${API.origin()}/admin/v1/consignments/${consignment.id}/documents/shipping-labels`,
                            target: GlobalConstants.PDF_WINDOW_TARGET_NAME,
                            icon: _jsx(TagsOutlined, {}),
                            label: "Shipping Labels"
                        }] }));
            }
        }];
    return (_jsxs(_Fragment, { children: [showButtonBar &&
                _jsxs("div", { className: "table-operations clearfix", children: [_jsxs(HasPermissions, { permissions: ['admin:consignment:create'], children: [_jsx(Button, { href: "#/app/consignments/create/details", title: "Add a new Delivery", icon: _jsx(PlusOutlined, {}), children: "Add a new Delivery" }), "\u00A0", _jsx(Button, { href: "#/app/consignments/quick-add", title: "Quick Add / Quote", icon: _jsx(PlusOutlined, {}), children: "Quick Add / Quote" })] }), _jsx(Button, { className: "pull-right", onClick: refresh, title: "Refresh", icon: _jsx(ReloadOutlined, {}) }), _jsx(PermissionButton, { permissions: ['admin:consignment:exportCsv'], className: "pull-right", onClick: downloadCsv, title: "Download CSV", icon: _jsx(DownloadOutlined, {}), children: "CSV" }), _jsx(Popconfirm, { title: "Downoad Proof of Deliveries for all Delivers?", description: _jsxs(_Fragment, { children: [_jsxs("p", { children: ["This will download a .zip archive containing Proof of Deliveries for ", _jsx("br", {}), "all ", ConsignmentStatusType.COMPLETED.renderTag(), " Delivers in the table."] }), _jsxs("p", { children: ["As this may take a while please ensure you have first applied any table ", _jsx("br", {}), "filters to only download what you need."] })] }), okText: "Download", onConfirm: downloadAllPODsAsZip, children: _jsx(Button, { className: "pull-right", disabled: !selectedTenant || stateDownloadingPODsZip, "aria-disabled": !selectedTenant, loading: stateDownloadingPODsZip, title: !selectedTenant ? "Select a profile to download all Proof of Deliveries" : "Download all Proof of Deliveries", icon: _jsx(FileZipOutlined, {}), children: "Proof of Deliveries" }) })] }), _jsx(PaginatedFilterableTable, { tableKey: 'consignmentsTable', ref: tableRef, dataUri: url, columns: columns, minWidthBeforeScrolling: 1000, refreshOnSelectedTenantChanged: true, saveChangesInSessionStorage: isBlankNullOrUndefined(filterSalesOrderRefQueryParam), initialFilters: {
                    "status": ConsignmentStatusType.defaultFilters(),
                    "salesOrderRefLike": filterSalesOrderRefQueryParam ? [filterSalesOrderRefQueryParam] : null
                } }), _jsx(ConsignmentAssignVehicleModal, { open: !!stateAssignConsignment, consignment: stateAssignConsignment, onCancel: hideAssignVehicleModal, onAssigned: (updatedConsignment) => {
                    if (tableRef.current) {
                        tableRef.current.updateRecord(updatedConsignment);
                    }
                    else {
                        refresh();
                    }
                    hideAssignVehicleModal();
                } }), _jsx(ConsignmentUnassignVehicleModal, { open: !!stateUnassignConsignmentId, consignmentId: stateUnassignConsignmentId, assignedAction: stateAssignedAction, assignedVehicleId: stateAssignedVehicleId, consignmentVersion: stateUnassignConsignmentVersion, onCancel: closeDialog, onUnassigned: (updatedConsignment) => {
                    if (tableRef.current) {
                        tableRef.current.updateRecord(updatedConsignment);
                    }
                    else {
                        refresh();
                    }
                    closeDialog();
                } }), _jsx(ConsignmentMarketplaceModal, { open: !!statePlaceOnMarketConsignment, consignment: statePlaceOnMarketConsignment, onCancel: hidePlaceOnMarketModal, onUpdated: () => {
                    hidePlaceOnMarketModal();
                    refresh();
                } }), _jsx(ConsignmentWithdrawFromMarketModal, { open: !!stateWithdrawFromMarketConsignment, consignment: stateWithdrawFromMarketConsignment, onCancel: hideWithdrawFromMarketModal, onUpdated: () => {
                    hideWithdrawFromMarketModal();
                    refresh();
                } }), _jsx(ConsignmentCancelModal, { open: !!stateCancelConsignmentId, consignmentId: stateCancelConsignmentId, consignmentVersion: stateCancelConsignmentVersion, onConsignmentCancelled: onConsignmentCancelled, onCancel: closeDialog }), _jsx(ConsignmentInstructionsPatchModal, { open: stateEditNotesConsignment !== null, consignment: stateEditNotesConsignment, onInstructionsUpdated: (result) => {
                    tableRef?.current?.updateRecord(result);
                    hideEditNotesConsignment();
                }, onCancel: () => hideEditNotesConsignment() })] }));
};
export default ConsignmentsTable;
